import { render, staticRenderFns } from "./Contenido.vue?vue&type=template&id=2a4749d6&scoped=true&"
import script from "./Contenido.vue?vue&type=script&lang=js&"
export * from "./Contenido.vue?vue&type=script&lang=js&"
import style0 from "./Contenido.vue?vue&type=style&index=0&id=2a4749d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4749d6",
  null
  
)

export default component.exports